import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-family__results" }
const _hoisted_2 = { class: "product-family__num-results" }
const _hoisted_3 = { class: "product-family__results-list" }
const _hoisted_4 = { class: "product-family__results-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductFamilyResultsCard = _resolveComponent("ProductFamilyResultsCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.results?.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, " Showing Results: 1 - " + _toDisplayString($props.results.length) + " of " + _toDisplayString($props.results.length), 1 /* TEXT */),
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.results, (result) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createVNode(_component_ProductFamilyResultsCard, {
                  type: result.itemType,
                  product: result.product,
                  category: result.category,
                  translations: $props.translations
                }, null, 8 /* PROPS */, ["type", "product", "category", "translations"])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}